var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41669 7.33325V11.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 7.33325V11.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 4V13.3333C13.4166 13.687 13.2762 14.0261 13.0261 14.2761C12.7761 14.5262 12.4369 14.6667 12.0833 14.6667H5.41665C5.06302 14.6667 4.72389 14.5262 4.47384 14.2761C4.22379 14.0261 4.08331 13.687 4.08331 13.3333V4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4H14.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08331 3.99992V2.66659C6.08331 2.31296 6.22379 1.97382 6.47384 1.72378C6.72389 1.47373 7.06302 1.33325 7.41665 1.33325H10.0833C10.4369 1.33325 10.7761 1.47373 11.0261 1.72378C11.2762 1.97382 11.4166 2.31296 11.4166 2.66659V3.99992",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "assets/b5919d1d863fb78dfe4656713024885d.svg";
export { SvgBin as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/bin.svg